import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'orderBy'
})

export class OrderByPipe implements PipeTransform {
    transform(value: any, filterBy: string, order: string): any {
        const filterByArray = filterBy.split(',');
        let orderNum: number;
        switch (order) {
            case 'asc':
                orderNum = 1;
                break;
            case 'desc':
                orderNum = -1;
                break;
            default:
                orderNum = 0;
                break;
        }
        if (!value || !filterBy || !orderNum) {
            return value;
        }
        return value.sort((a: any, b: any) => {
            // We go for each property followed by path
            filterByArray.forEach(f => {
                a = a[f];
                b = b[f];
            });
            // Order * (-1): We change our order
            return a > b ? orderNum : orderNum * (- 1);
        });
    }
}
